import { render } from "./productcomponent.vue?vue&type=template&id=6139ed68&scoped=true"
import script from "./productcomponent.vue?vue&type=script&lang=js"
export * from "./productcomponent.vue?vue&type=script&lang=js"

import "./productcomponent.vue?vue&type=style&index=0&id=6139ed68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6139ed68"]])

export default __exports__